import React, { useEffect ,  useContext} from "react";
import "../style.css";
import { CurrencyContext } from "./CurrencyContext";


const CruiseSearchWidget = () => {
     const { selectedCurrency } = useContext(CurrencyContext);
  
  useEffect(() => {
    // Load external scripts dynamically
    const loadScript = (src, async = true) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = async;
      document.body.appendChild(script);
    };

    // Load jQuery and Bootstrap
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js");
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.1.1/js/bootstrap.min.js");
    
    // Load Elementor and Widget script
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/elementor/3.6.0/elementor.min.js");
    loadScript("https://content.cdn705.com/Content/WebApps/OdyVExplore/OVExplore.min.js");

    // Initialize search form settings
    window.OVExplore10 = {
      preferences: {
        languageId: "1",
        siteItemId: selectedCurrency,
        sid1: "",
        sid2: "",
        referrer: "",
        resultWindowType: "_self",
        showStateNCountryWithPorts: true,
        cruiseSearchFields: {
          basic: ["destination", "sailingdate", "departureport", "cruiseline"],
        },
      },
      siteSettings: {
        productType: "cruise",
        domain: "booking.int2cruises.com",
        numberOfCols: 6,
        themeColor: "#0000|#F99F1D|#164D55|#164D55",
      },
    };

    // Prevent form reload on submission
    const handleFormSubmit = (event) => {
      event.preventDefault();
      console.log("Form submission prevented to retain data.");
    };

    // Attach event listener after component mounts
    const searchForm = document.querySelector("ody-search-form");
    if (searchForm) {
      searchForm.addEventListener("submit", handleFormSubmit);
    }

    // Cleanup function to remove event listener
    return () => {
      if (searchForm) {
        searchForm.removeEventListener("submit", handleFormSubmit);
      }
    };
  }, [selectedCurrency]);

  return (
    <div className="container-fluid">
      <div className="tab-content border border-top-0 mb-3 custom-tab-content" style={{backgroundColor:'transparent'}}>
        <div className="tab-pane pt-2 fade show active"  style={{backgroundColor:'transparent'}}>
          <div className="cruiseform">
            <div className="od-form-wrapper"  style={{backgroundColor:'transparent', boxShadow:'none', padding:'0'}}>
              <ody-search-form search-form-settings="OVExplore10"></ody-search-form>
            </div>
          </div>
        </div>
      </div>

      {/* Preload Critical CSS */}
      <link rel="stylesheet" href="https://int2cruises.com/wp-content/uploads/2025/03/form10-1-3.css" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.1.1/css/bootstrap.min.css" />

      {/* Custom inline CSS for label underline effect */}
      <style>
        {`
          label, .multiselect__placeholder, .multiselect__single {
            display: inline-block;
            position: relative;
          }
          label::after, .multiselect__placeholder::after, .multiselect__single::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -2px;
            width: 100%;
            height: 2px;
            background-color: black;
          }
        `}
      </style>
    </div>
  );
};

export default CruiseSearchWidget;
